import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { isUndefined } from '@sama/micro-dash';
import { DirectiveSuperclass } from '@sama/ng-core';
import { map, Observable, of } from 'rxjs';
import { isHandledByOtherDirective } from '../../../../cross-team-shared/scroll-enabler.directive';
import { EventTrackingService } from '../../../../shared/event-tracking/event-tracking.service';
import { getOutputHelper } from '../../../../shared/output-helpers/get-output-helper';
import { Output } from '../../../../team-apis/otterdam/outputs/output';
import { FeatureFlagService } from '../../../shared/misc-services/feature-flag.service';
import { resetOutput } from '../../state/output-info';
import { TaskWorkspaceStore } from '../../state/task-workspace-store';
import {
  getOutputByName,
  isAnnotationOutput,
} from '../sensor-fusion/sensor-fusion-output.utils';

@Component({
  selector: 'h3-output',
  templateUrl: './output.component.html',
  styleUrls: ['./output.component.scss'],
  providers: [EventTrackingService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OutputComponent extends DirectiveSuperclass implements OnInit {
  @Input({ required: true }) name!: string;
  output!: Output;
  isClearAnswerButtonVisible$?: Observable<boolean>;
  showFieldFeedbackFooter!: boolean;

  private elementRef = inject(ElementRef);
  private taskWorkspaceStore = inject(TaskWorkspaceStore);
  private featureFlagService = inject(FeatureFlagService);

  ngOnInit() {
    this.output = getOutputByName(
      this.taskWorkspaceStore.state().project,
      this.name,
    );
    if (!this.taskWorkspaceStore.state().selectedOutputName) {
      this.taskWorkspaceStore('selectedOutputName').set(this.output.name);
    }
    this.isClearAnswerButtonVisible$ = this.initClearAnswerObservable();
    this.showFieldFeedbackFooter = this.buildShowFieldFeedbackFooter();
  }

  onWheel(event: WheelEvent) {
    isHandledByOtherDirective(
      event,
      event.target as HTMLElement,
      this.elementRef.nativeElement,
    );
  }

  resetOutput() {
    resetOutput(this.taskWorkspaceStore('outputInfoByName')(this.name));
  }

  private initClearAnswerObservable() {
    if (isUndefined(this.output)) {
      return of(false);
    }
    const outputHelper = getOutputHelper(this.output.type);
    if (
      isAnnotationOutput(this.output) ||
      this.taskWorkspaceStore.state().readOnly
    ) {
      return of(false);
    }
    return this.taskWorkspaceStore('outputInfoByName')(this.name)(
      'answer',
    ).$.pipe(map((answer) => !outputHelper.isAnswerBlank(answer)));
  }

  private buildShowFieldFeedbackFooter() {
    return (
      this.featureFlagService.hasFlag('new-sampling-nav') &&
      !isAnnotationOutput(this.output)
    );
  }
}
